export default () => {
	const list = document.querySelectorAll('[data-form-class]');
	const modal = document.querySelector('.subscription__modal');
	const openModalBtn = document.querySelectorAll('.subscription__selector');
	const closeModalBtn = document.querySelector('.subscription__close');

	for (const iterator of list) {
		iterator.addEventListener('click', () => {
			const selector = iterator.getAttribute('data-form-class');
			const form = iterator.parentElement.parentElement.parentElement.querySelector(`form.${selector}`);
			form.submit();
		});
	}

	/**
	 * Function to close subscription modal
	 */
	function closeModal() {
		modal.style.display = 'none';
		document.body.removeAttribute('style');
	};

	for (var i = 0; i < openModalBtn.length; i++) {
		var thisBtn = openModalBtn[i];
		thisBtn.addEventListener('click', function() {
			var modal = document.getElementById(this.dataset.modal);
			modal.style.display = 'block';
			document.body.style.position = 'fixed';
		}, false);
	}

	closeModalBtn && closeModalBtn.addEventListener('click', closeModal);

	document.addEventListener('keydown', function(e) {
		if (e.key === 'Escape' && !modal.classList.contains('hidden')) {
			closeModal();
		}
	});
};
